export default __webpack_public_path__ + "static/media/HSLOpenMaaSAuthorisation_EN.731274ba.pdf";